import axiosPost from "./axiosPost";

export const RNHNivelGet = async (credentials, data) => {
    const body = {
        service: "RNHNivelGet",
        params: {
            rnhNivelId: data?.rnhZonaId || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
